import { useAuth } from "@/context/AuthContext";

export default function TopBar({ variant = "admin" }) {
  const { user } = useAuth();
  return (
    <div
      data-testid="top-bar"
      className="h-14 border-b border-border flex items-center px-5 sm:px-8 bg-background/70 backdrop-blur"
    >
      {variant === "admin" && user ? (
        <div className="flex items-center gap-2 min-w-0">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shrink-0" />
          <span className="label-mono truncate">{user.role?.replace("_", " ")}</span>
          <span className="text-muted-foreground">·</span>
          <span className="text-sm truncate">{user.name}</span>
        </div>
      ) : null}
    </div>
  );
}
